import { render, staticRenderFns } from "./home-banners-slider.vue?vue&type=template&id=3aec5f2f&scoped=true"
import script from "./home-banners-slider.vue?vue&type=script&lang=js"
export * from "./home-banners-slider.vue?vue&type=script&lang=js"
import style0 from "./home-banners-slider.vue?vue&type=style&index=0&id=3aec5f2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aec5f2f",
  null
  
)

export default component.exports